/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Xml_Feed_Url_LabelInputs */

const cs_xml_feed_url_label = /** @type {(inputs: Xml_Feed_Url_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL feedu`)
};

const en_xml_feed_url_label = /** @type {(inputs: Xml_Feed_Url_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feed URL`)
};

/**
* | output |
* | --- |
* | "Feed URL" |
*
* @param {Xml_Feed_Url_LabelInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const xml_feed_url_label = /** @type {((inputs?: Xml_Feed_Url_LabelInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Xml_Feed_Url_LabelInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_xml_feed_url_label(inputs)
	return cs_xml_feed_url_label(inputs)
});